<script>
	import journey from "../../stores/journey.js";
	import semaphore from "../../stores/semaphore.js";
	import { compassDirectionDisplayName } from "../../helpers/geo.js";
	import Model from "./vehicle/Model.svelte";
	import Noise from "./vehicle/Noise.svelte";
	import t from "../../localization/t.js";
	import { ME } from "../../api/socket.js";
	import Plate from "./vehicle/Plate.svelte";

	const NOISE_ENABLED = true;

	export let window;

	let speed = 0.0;
	let targetSpeed = 0.0;

	$: (() => {
		if ($journey.isEnded || $journey.location?.speed === undefined || $semaphore.isPaused) {
			targetSpeed = 0.0;
			return;
		}

		targetSpeed = $journey.location.speed;
	})();

	function updateSpeed() {
		speed = speed + (targetSpeed - speed) * 0.001;

		const delta = Math.abs(Math.round(speed) - Math.round(targetSpeed));

		if (delta > 0) {
			requestAnimationFrame(updateSpeed);
		}
	}

	$: targetSpeed !== speed && updateSpeed();

	let heading = 0.0;
	let rotation = 0.0;

	$: (() => {
		if (!$journey.location || $journey.location.heading === undefined) {
			return;
		}

		const rad = (deg) => (deg / 180.0) * Math.PI;
		const target = -rad($journey.location.heading) - Math.PI * 0.385 + rotation;

		if (heading) {
			heading = heading + (target - heading) * 0.05;
		} else {
			heading = target;
		}
	})();

	function map(n, low1, high1, low2, high2) {
		return low2 + (high2 - low2) * ((n - low1) / (high1 - low1));
	}

	$: volume = map(speed * 2.23694, 10.0, 120.0, 0.075, 0.5);

	$: info =
		speed < 1.0 && $semaphore.note
			? $semaphore.note
			: !$journey.location
			? ""
			: t("vehicle.status", {
					direction: compassDirectionDisplayName($journey.location.compass).toLowerCase(),
					speed: (speed * 2.23694).toFixed()
			  });

	function didChangeMouseWheel(e) {
		if (window.isFocused) {
			rotation += (e.deltaX === 0.0 ? e.deltaY : e.deltaX) / 500.0;
		}
	}

	function didLeaveMouse() {
		rotation = 0.0;
	}
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->

<div class="vehicle" on:mousewheel={didChangeMouseWheel} on:mouseleave={didLeaveMouse}>
	{#if NOISE_ENABLED}
		<div class="noise">
			<Noise {volume} />
		</div>
	{/if}

	<div class="model">
		<Model {heading} {speed} />
	</div>

	<div class="info">
		{info}
		<Plate number={ME} />
	</div>
</div>

<style>
	.vehicle {
		position: relative;
		height: 100%;
		overflow: hidden;
	}

	.model {
		position: relative;
		top: -0.5em;
		aspect-ratio: 1.5/1;
		overflow: hidden;
	}

	.info {
		display: flex;
		flex-direction: column;
		position: absolute;
		bottom: var(--spacing);
		box-sizing: border-box;
		padding: 0 3%;
		width: 100%;
		line-height: 200%;
		align-items: center;
		gap: 4px;
	}

	.noise {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 80%;
		pointer-events: none;
	}
</style>
